import React, { Component } from "react";
import Carousel from "nuka-carousel";
import "./IndustryBannerCarousel.css";

function IndustryBannerCarousel() {
  return (
    <div style={{ width: "100%" }} id="IndustryBannerCarousel">
      <Carousel
        autoplay="false"
        wrapAround={false}
        renderCenterLeftControls={({ previousSlide }) => (
          <button onClick={previousSlide} className="preBtn">
            &lsaquo;
          </button>
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <button onClick={nextSlide} className="nextBtn">
            &rsaquo;
          </button>
        )}
      >
        <div className="nuka-box">
          <img
            src="images/Industry/Banner 1.png"
            alt="banner"
            className="banner-img"
          />
          {/* <div className="banner-text">
          <h1>Industry Learning Academy</h1>
          <p>Gain deep industry knowledge and expertise</p>
        </div> */}
        </div>
        <div className="nuka-box">
          <img
            src="images/Industry/Banner 2.png"
            alt="banner"
            className="banner-img"
          />
          {/* <div className="banner-text">
          <h1>Industry Learning Academy</h1>
          <p>Build industry skill to understand client's business better</p>
        </div> */}
        </div>
        <div className="nuka-box">
          <img
            src="images/Industry/Banner 3.png"
            alt="banner"
            className="banner-img"
          />
          {/* <div className="banner-text">
          <h1>Industry Learning Academy</h1>
          <p>
            Enhance industry knowledge to have quality conversations with client
          </p>
        </div> */}
        </div>
      </Carousel>
    </div>
  );
}

export default IndustryBannerCarousel;
